import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import theme from './theme/theme';
import { TunnelProvider } from './context/TunnelContext';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <TunnelProvider>
          <AppRoutes />
        </TunnelProvider>
      </BrowserRouter>
      <ToastContainer position="bottom-right" autoClose={5000} />
    </ThemeProvider>
  );
}

export default App;
